module.exports = __webpack_public_path__ + "static/media/mybank.593e939a.svg";